<template>
    <div class="field-container-2">
        <div class="regular-type-header">
            {{header}}
        </div>
        <v-text-field
                type="number"
                :hint="description"
                :persistent-hint="true"
                color="accent"
                v-model="value"
                :rules="validationRules"
                :required="isRequired"
                @input="emitInput"
                v-on:update:error="emitValidationState"
        ></v-text-field>
    </div>

</template>

<script>
    import {
        EVENT_INPUT,
        EVENT_TOUCHED,
        EVENT_VALIDATION_STATE,
        DEFAULT_LOCALE,
        GET_LOCALE_DISPLAY_NAME,
    } from '../../services/constants'

    export default {
        name: 'sfr-number-field',
        props: {
            field: Object,
            valid: Boolean,
            inputValue: Number,
        },
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            return {
                isRequired: this.field.required,
                value: this.inputValue
            }
        },
        computed: {
            header: function () {
                return this.computeFieldHeader(this.field)
            },
            isValid: function () {
                return this.valid
            },
            validationRules: function () {
                return [
                    this.isRequired ? v => !!v || `${this.field.name} is required` : () => true,
                ]
            },
            description: function () {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
        },
        methods: {
            computeFieldHeader: function (field) {
                return `${field.name}${field.required ? '* ' : ''}:`
            },
            emitInput: function ($event) {
                if ($event === '') {
                    this.$emit(EVENT_INPUT, null)
                } else {
                    this.$emit(EVENT_INPUT, Number($event))
                }
                this.$emit(EVENT_TOUCHED, true)
            },
            emitValidationState: function ($event) {
                this.$emit(EVENT_VALIDATION_STATE, !$event)
            },
            validate: function () {
                const validationResult = !this.validationRules.map(ruleFunc => {
                    const ruleResult = ruleFunc(this.value)
                    if (ruleResult !== true) {
                        this.validationText = ruleResult
                    } else {
                        this.validationText = ''
                    }
                    return ruleResult === true
                }).some(validationResult => {
                    return validationResult === false
                })
                if (validationResult !== this.isValid) {
                    this.emitValidationState(!validationResult)
                }
            },
        },
        created: function () {
            this.validate()
        },
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .regular-type-header {
        font-size: 14px;
        .input-group {
            padding: 0px;
        }
    }


</style>
